const initialState = [];

function categoriesReducer(state = initialState, action) {
    switch (action.type) {
        case 'SET_ALL_CATEGORIES':
            return action.payload.map(categories => {
                return {
                    ...categories,
                    selected: false
                }
            })
        case 'SELECT_CATEGORY':
            return state.map(categories => {
                if (categories.id !== action.id) {
                    return categories
                }
                categories.selected = !categories.selected
                return categories
            })
        case 'REMOVE_CATEGORY':
            return state.filter(category => category.id !== action.id)
        default:
            return state
    }
}

export default categoriesReducer
